import { useMemo } from 'react';

interface Filters {
  searchTerm: string;
  selectedBrands: string[];
  priceRange: [number, number];
  cyod: boolean;
}

interface UseProductFilterResult {
  filteredItems: Product[];
  loading: boolean;
}

export const useProductFilter = (
  categoryItems: Product[],
  filters: Filters
) => {
  const filteredItems = useMemo(() => {
    return categoryItems.filter((item) => {
      const isPriceInRange =
        Number.isFinite(filters.priceRange[0]) &&
        Number.isFinite(filters.priceRange[1]) &&
        item.sale_price / 1.21 >= filters.priceRange[0] &&
        item.sale_price / 1.21 <= filters.priceRange[1];

      return (
        item.name.toLowerCase().includes(filters.searchTerm.toLowerCase()) &&
        (filters.selectedBrands.length === 0 ||
          filters.selectedBrands.includes(item.brand_name)) &&
        (isPriceInRange ||
          !Number.isFinite(filters.priceRange[0]) ||
          !Number.isFinite(filters.priceRange[1])) &&
        (filters.cyod ? item.isCyod : true)
      );
    });
  }, [categoryItems, filters]);

  return { filteredItems };
};
